import { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import MiniDrawer from "../MiniDrawer/MiniDrawer";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import CryptoJS from "crypto-js";
import Wrapper from "../../components/UI/Wrapper";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from "react-router-dom";

function FieldOpsExpenseList() {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [fieldOpsResponse, setFieldOpsResponse] = useState(null);
  const [relocationId, setRelocationId] = useState("");
  const [expense_Type, setExpense_Type] = useState(null);
  const location = useLocation();
  const [expenseDoc, setExpenseDoc] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const relocationId = queryParams.get("Relocation_Id");
    decryptRelocationID(relocationId);
    getExpenseTypeList();
    setRelocationId(relocationId);
  }, []);

  
  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd"
      );
      setRelocationId(bytes.toString(CryptoJS.enc.Utf8));

      getFieldOpsExpenseList(bytes.toString(CryptoJS.enc.Utf8));
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);
      return null;
    }
  }

  function getExpenseTypeList() {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsExpenseTypeList`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setExpense_Type(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  function getCurrentExpenseType(Id) {
    if (Id !== null && Id !== undefined && expense_Type !== null) {
      const expenseType = expense_Type.find((type) => type.Tseed == Id);
      if (expenseType !== undefined) {
        return expenseType.TYPE;
      }
    }
  }

  function getFieldOpsExpenseList(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}UserGet/GetFieldOpsExpenseDetail?RelocationId=${id}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setFieldOpsResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const navigate = useNavigate();
  
  function nextPage1() {
    navigate("/ExpenseList");
    // const url = `/ExpenseList`;
    // window.open(url, '_self');
  }

 
  return (
    <div className=" d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid fieldOpsexpenseList" style={{ backgroundColor: "#F4F4F4" }}>
        <div style={{ marginTop: "90px" }}>
          <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
            Expense| <HomeOutlinedIcon />{" "}
            <span style={{ fontSize: "20px" }}>&gt; Operations</span>{" "}
            <a
              style={{ color: "black", textDecoration: "none",cursor:"pointer" }}
            >
              <span style={{ fontSize: "20px" }} onClick={nextPage1}>&gt; Expense</span>
            </a>
            <span style={{ fontSize: "20px" }}>&gt; Expense List</span>
          </h1>
        </div>
        <Wrapper className="ViewLeadDetails">
        <table
          style={{ marginBottom: "1rem", borderRadius: "6px 6px 0px 0px" }}
        >
          <tr>
            <th
              colSpan={8}
              style={{
                backgroundColor: "#5B489D",
                color: "white",
                fontSize: "20px",
                borderRadius: "18px 18px 0px 0px",
              }}
            >
              {" "}
              Expense List
            </th>
          </tr>
        </table>
        <table style={{ width: "100%" }} className="table_supplier">
          <thead>
            <tr className="employeeListHeading">
              <th>S.No.</th>
              <th>Relocation ID</th>
              <th>Job ID</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Expense Type</th>
              <th>Document</th>
            </tr>
          </thead>
          <tbody>
            {fieldOpsResponse !== null ? (
              fieldOpsResponse.map((item, index) => (
                <tr key={index}>
                  <td>{item.Expense_Id}</td>
                  <td>{item.Relocation_Id}</td>
                  <td>{item.Job_Id}</td>
                  <td>{item.Amount}</td>
                  <td>{item.Description}</td>
                  <td>{getCurrentExpenseType(item.Expense_Type)}</td>
                  {item.Document !== "" ? (
                    <td>
                      {" "}
                      <a
                        style={{
                          color: "#6a6a6a",
                          textDecoration: "none",
                          cursor: "pointer",
                          fontWeight: "bold",
                        }}
                        target="_blank"
                        href={`${baseImageURL}Images/FieldOpsExpenseDocuments/${item.Document}`}
                      >
                        View Document <ArrowForwardIcon />
                      </a>
                    </td>
                  ) : (
                    <td>
                      {" "}
                      <p style={{ color: "#6a6a6a", textDecoration: "none" }}>
                        No Document Uploaded
                      </p>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="15">No Expense Has Been Added</td>
              </tr>
            )}
          </tbody>
        </table>
      </Wrapper>
      </div>
    </div>
  );
}

export default FieldOpsExpenseList;
